import React, { ReactElement } from 'react';
import { IconButton, Typography } from '@zydalabs/storefront-components';

import { customHistory } from 'common/utils';
import { IcBack } from 'common/icons';
import { StyledHeaderWrapper, StyledTitleWrapper } from './style';

type HeaderProps = {
  title?: string;
  onBack?: () => void;
  additionalElement?: ReactElement;
};

const StoreFrontHeader: React.FC<HeaderProps> = ({ title, onBack, additionalElement }) => (
  <StyledHeaderWrapper>
    <IconButton icon={IcBack} onClick={() => (onBack ? onBack() : customHistory.back())} testId="backIconButton" reverseOnRtl />
    <StyledTitleWrapper additionalElement={additionalElement}>
      {title && <Typography variant="headlineBody">{title}</Typography>}
    </StyledTitleWrapper>
    {additionalElement && additionalElement}
  </StyledHeaderWrapper>
);

export default StoreFrontHeader;
